import { useQuery } from "@apollo/client"
import { gql } from "~/__generated__"

gql(/* GraphQL */ `
  fragment UserProfile on User {
    id
    handle
    firstName
    lastName
    fullName
    bio
    isContact
    createdAt
    userStatus
    visibilityWalletIndex
    visibilityContactIndex

    wallets {
      id
      publicKey
      publicKeyFormatted
      provider
      providerVersion
      providerDisplayName
      connectionMethod
    }
    avatarUrl
    avatarThumbUrl
    emails {
      id
      email
      status
    }
    phones {
      id
      phone
      phoneFormatted
      status
    }
  }
`)

gql(/* GraphQL */ `
  fragment ContactProfile on Contact {
    id
    notes
    tags {
      id
      name
    }
    visibleFields
  }
`)

const USER_PROFILE_QUERY = gql(/* GraphQL */ `
  query UserProfile($handle: String, $contactSearchId: String) {
    userProfile(handle: $handle, contactSearchId: $contactSearchId) {
      user {
        ...UserProfile
      }
      contact {
        ...ContactProfile
      }
      isOwnProfile
      accessContext
    }
  }
`)

export const useProfileData = (handle?: string, csrid?: string) => {
  const queryResult = useQuery(USER_PROFILE_QUERY, {
    variables: {
      handle: csrid ? undefined : handle,
      contactSearchId: csrid || undefined,
    },
    skip: !handle && !csrid,
  })

  const profileData = queryResult.data?.userProfile

  return {
    ...queryResult,
    user: profileData?.user,
    contact: profileData?.contact,
    isOwnProfile: profileData?.isOwnProfile || false,
    accessContext: profileData?.accessContext,
  }
}
